import React, { memo, useCallback } from "react";
import { EditorToolbar } from "../../../../react/EditorToolbar/EditorToolbar";
import { EditorToolbarButton, } from "../../../../react/EditorToolbarButton/EditorToolbarButton";
import { calloutColors, calloutTitles, calloutTypeIcons, calloutTypes, removeCalloutTitle, } from "../../constants";
const EditorCalloutMenuRaw = ({ type, onTypeChange, onRemove, }) => {
    const handleTypeChange = useCallback((calloutType) => () => {
        onTypeChange(calloutType);
    }, [onTypeChange]);
    const handleRemove = useCallback(() => {
        onRemove();
    }, [onRemove]);
    return (React.createElement(EditorToolbar, { preventFocusOnClick: true },
        calloutTypes.map((calloutType) => (React.createElement(EditorToolbarButton, { key: calloutType, icon: calloutTypeIcons[calloutType], color: calloutColors[calloutType], title: calloutTitles[calloutType], active: calloutType === type, light: true, "aria-selected": calloutType === type, onClick: handleTypeChange(calloutType) }))),
        React.createElement(EditorToolbarButton, { icon: "trash-duotone", iconSize: "S", color: "red", kind: "bg", light: true, title: removeCalloutTitle, onClick: handleRemove })));
};
export const EditorCalloutMenu = memo(EditorCalloutMenuRaw);
